import type {FunctionComponent} from "react";
import React from "react";
import s from "./MusicGroupPage.module.scss";
import BackButton from "../../components/common/BackButton";
import TabbedNavigation from "../../components/tabbedNavigation/TabbedNavigation";

interface IMusicGroupPageProps {
  title: string;
  onBack: () => void;
}

export const MusicGroupPage: FunctionComponent<IMusicGroupPageProps> = ({title, children, onBack}) => {
  return (
    <div className={s.container}>
      <header className={s.header}>
        <BackButton label={'Back'} useClassName={s.backButton} onClick={onBack} />
        <h1>{title}</h1>
      </header>
      <main className={s.scrollableContent}>
        <div className={s.cards}>
          {children}
        </div>
      </main>
      <footer className={s.footer}>
        <TabbedNavigation/>
      </footer>
    </div>
  );
}
